import { toast } from "@bleu.builders/ui";
import { assign, fromPromise, setup } from "xstate";

import { client } from "#/utils/api-client";

const createReusableSharedLinkLogic = fromPromise(
  async ({ input: { data } }: { input: { data: object } }) => {
    const response = await client(`/reusable_diagnosis_links`, {
      // @ts-ignore
      body: data,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    if (!response.success) {
      toast({
        title: "Erro!",
        description: response.errors,
        variant: "destructive",
      });
    }

    return response;
  },
);

export const diagnosesCreationStateMachine = setup({
  actors: { createReusableSharedLinkLogic },
}).createMachine({
  id: "sharedLinkToCreateDiagnoses",
  initial: "confirmation",
  context: {
    externalUrl: null,
    creationError: null,
  },
  states: {
    confirmation: {
      on: {
        SUBMIT_LINK_DATA: "creationInProgress",
      },
    },
    creationInProgress: {
      invoke: {
        src: "createReusableSharedLinkLogic",
        input: (context) => ({
          data: {
            organization_id: context.event.organizationId,
          },
        }),
        onDone: {
          target: "linkCreated",
          actions: assign({
            externalUrl: ({ event }) => event.output?.external_url,
          }),
        },
        onError: {
          target: "linkCreationError",
          actions: assign({
            creationError: () => "Erro ao criar diagnóstico externo",
          }),
        },
      },
    },
    linkCreationError: {
      /* render error component */
    },
    linkCreated: {
      /* render success message or copy link component */
    },
  },
});
